import React, { useCallback } from 'react';
import styled from 'styled-components';
import { COLORS, FlexView, Row } from '@cuemath/comps';
import { Text, TextInput } from '@cuemath/web-comps';

const SelectionCard = styled(FlexView)`
  width: ${({ width }) => width};
  gap: ${({ gap }) => gap || 8}px;
  padding: 0;
`;

const CourseSelectionRadios = styled(Row)`
  gap: 74px;
`;

const Label = styled.label`
  display: flex;
  gap: 6px;
  cursor: pointer;
`;

const Input = styled.input`
  appearance: none;
  width: 24px;
  height: 24px;
  display: grid;
  justify-content: center;
  align-content: center;
  cursor: pointer;

  &::before {
    content: '';
    width: 7px;
    height: 7px;
    border-radius: 50%;
    outline: 2px solid ${COLORS.COLA};
    outline-offset: 2px;
  }

  &:checked::before {
    background-color: ${COLORS.COLA};
  }
`;

const courseTypeRadioButtons = [
  {
    key: 'preferred-teacher-math-course',
    title: 'Math',
    value: 'MATH',
  },
  {
    key: 'preferred-teacher-coding-course',
    title: 'Coding',
    value: 'CODING',
  },
];

const PreferredTeacherSelected = ({ preferredTeacherData, setPreferredTeacherData }) => {
  const { courseSelected, preferredTeacherId } = preferredTeacherData || {};

  const handleSetPreferredTeacherData = useCallback(
    value => {
      setPreferredTeacherData(prev => ({ ...prev, ...value }));
    },
    [setPreferredTeacherData],
  );

  return (
    <>
      <SelectionCard alignItems="flex-start" justifyContent="center" gap={16}>
        <Text variant="h6">Select a course to initiate transfer</Text>

        <CourseSelectionRadios alignItems="center" justifyContent="space-between">
          {courseTypeRadioButtons.map(buttonData => {
            const { title, key, value } = buttonData || {};
            const selected = value === courseSelected;

            return (
              <Label
                key={key}
                onClick={() => handleSetPreferredTeacherData({ courseSelected: value })}
              >
                <Input type="radio" checked={selected} />
                <Text variant="body1Regular">{title}</Text>
              </Label>
            );
          })}
        </CourseSelectionRadios>
      </SelectionCard>

      <SelectionCard alignItems="flex-start" justifyContent="center" gap={24}>
        <Text variant="h6">Provide preferred teacher id.</Text>
        <TextInput
          value={preferredTeacherId}
          onChange={value => handleSetPreferredTeacherData({ preferredTeacherId: value })}
          width="320px"
          label="Teacher ID"
        />
      </SelectionCard>
    </>
  );
};

export default PreferredTeacherSelected;
